<template>
  <div>
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item>帮忙</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <div class="cont">
      <!-- 上半部分-->
      <div class="topp">
        <div class="topnav">
          <!-- 上左边 -->
          <div class="topnavleft">
            <!-- logo -->
            <div class="top">
              <div>
                <img
                  src="@/assets/community/back.png"
                  alt=""
                  class="top-left-img"
                  @click="back"
                />
              </div>
              <div>
                <img
                  src="@/assets/work/wodebangzhu.png"
                  alt=""
                  class="top-midlle-img"
                />
              </div>
              <div class="top-midlle-span">帮忙详情</div>
            </div>
            <!-- logo下面的文字 -->
            <div class="topb">
              <div class="topbtext">
                <p>提交时间</p>
                <span>{{ info.created_at }}</span>
              </div>
              <div class="topbtext">
                <p>审核时间</p>
                <span>{{ info.examine_at }}</span>
              </div>
            </div>
          </div>
          <!-- 上右边 审核的logo-->
          <div>

            <img
              v-if="info.status === 0"
              src="@/assets/tender/tenderapprove.png"
              alt=""
              class="topnavright-img"
            />
            <img
              v-if="info.status === 1"
              src="@/assets/tender/tenderpass.png"
              alt=""
              class="topnavright-img"
            />
            <img
              v-if="info.status === 3"
              src="@/assets/tender/tenderreject.png"
              alt=""
              class="topnavright-img"
            />
          
          </div>
        </div>
        <div class="space">
          <div class="aaaa"></div>
        </div>
      </div>

      <!-- 下半部分 -->
      <div class="bottom">
        <!-- tab标签 -->
        <div class="tablabel">
          <!-- 基本信息 -->
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基本信息" name="first">
              <div class="information">
                <p>项目标题</p>
                <span>{{ info.title }}</span>
              </div>
              <div class="information">
                <p>项目简介</p>
                <span>{{ info.sketch }}</span>
              </div>
              <div class="information">
                <div>
                  <p>员工工资</p>
                  <span>{{ info.wages }}元</span>
                </div>
                <div>
                  <p>佣金</p>
                  <span>{{ info.commission }}元</span>
                </div>
                <div>
                  <p>佣金结算方式</p>
                  <span>{{ info.com_settle_type|comSettleTypesFilter }}</span>
                </div>
              </div>
              <div class="information">
                <div>
                  <p>起始时间</p>
                  <span>{{ info.start_at }}</span>
                </div>
                <div>
                  <p>结束时间</p>
                  <span>{{ info.end_at }}</span>
                </div>
              </div>
              <div class="information">
                <p>招标描述</p>
                <span>{{ info.description }}</span>
              </div>
            </el-tab-pane>
            <!-- 对投标人要求 -->
            <el-tab-pane label="对投标人要求" name="second">
              <div class="requirements">
                <div>
                  <p>允许投标名额</p>
                  <span>{{ info.bid_number }}人</span>
                </div>
                <div>
                  <p>投标人地区</p>
                  <span>{{ info.region }}</span>
                </div>
                <div>
                  <p>投标人类型</p>
                  <!--1.个人 2.社团 3.企业-->
                  <span>{{ info.bid_type==1?"个人":info.bid_type==12?"社团":"企业" }}</span>
                </div>
              </div>
              <div class="requirements">
                <div>
                  <p>联系人</p>
                  <span>{{ info.contacts }}</span>
                </div>
                <div>
                  <p>联系电话</p>
                  <span>{{ info.mobile }}</span>
                </div>
              </div>
              <div class="requirements">
                <div>
                  <p>多人中标</p>
                  <span>{{ info.many_bid==1?"允许":"不允许" }}</span>
                </div>
                <div>
                  <p>邮箱地址</p>
                  <span>{{ info.email }}</span>
                </div>
              </div>
              <div class="requirements">
                <div>
                  <p>附件</p>
                  <span>{{ info.annex_name }}</span>
                </div>
                <div>
                  <p></p>
                  <span></span>
                </div>
              </div>
              <div class="requirements">
                <p>附件地址</p>
                <span>{{ info.annex_url }}</span>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { webCrowdInfo } from "@/api/director/package/index";

export default {
  data() {
    return {
      crowd_id:"",
      info:{},
      activeName: "first",

      

    };
  },
  filters: {
    comSettleTypesFilter(status) {
      const statusMap = {
        1: '日结',
        2: '周结',
        3: '月结',
        4:'完工结',
        5:'入职结'
      }
      return statusMap[status]
    },
    comTypesFilter(status) {
      const statusMap = {
        1: '按人',
        2: '按件',
        3: '总价',
      }
      return statusMap[status]
    }
  },
  mounted() {
    console.log(this.$route.query);
    if (this.$route.query.crowd_id != "") {
      this.crowd_id = this.$route.query.crowd_id;
      this.initData();
      // 获取接口
    }
  },

  methods: {
      // 获取列表的方法
    initData() {
      webCrowdInfo({crowd_id:this.crowd_id}).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.info=res.data;
         
        } else {
          this.$message.error(res.msg ? res.msg : "请求错误");
        }
      });
    },

    back() {
      this.$router.go(-1);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getData() {
      // this.number = n;
    },

    formatDateTime(value) {
      // 时间戳转换日期格式方法
      if (value == null) {
        return "";
      } else {
        const date = new Date(value);
        const y = date.getFullYear(); // 年
        let MM = date.getMonth() + 1; // 月
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate(); // 日
        d = d < 10 ? "0" + d : d;
        let h = date.getHours(); // 时
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes(); // 分
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds(); // 秒
        s = s < 10 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      }
    },
  },


};
</script>

<style lang="scss" scoped>
.topp {
  height: 152px;
  background-color: white;
  margin-bottom: 10px;
}

.space {
  height: 30px;
  background-color: #f8f8f8;
  width: 980px;
  margin-left: -20px;
}

.aaaa {
  position: relative;
  // padding: 2px;
  background: white;
  width: 623px;
  height: 1px;
  border-radius: 25px;
}

.aaaa::after {
  position: absolute;
  border-radius: 5px;
  content: "";
}

.cont {
  width: 100%;

  .topnav {
    height: 152px;
    background-color: white;
    display: flex;
    justify-content: space-between;

    .topnavleft {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .topb {
        display: flex;
        justify-content: space-between;
        margin-left: 25px;
      }

      .topbtext {
        margin-right: 20px;

        p {
          font-size: 13px;
          color: #000000;
          font-weight: 500;
        }

        span {
          font-size: 11px;
        }
      }
    }

    .topnavright-img {
      width: 72px;
      height: 72px;
      margin: 41px 43px 39px 0px;
    }
  }

  .bottom {
    width: 950px;
    height: 448px;
    background-color: white;
    margin-top: 10px;
    margin-left: -20px;
    margin-right: -30px;
    border-radius: 5px;
    padding: 15px;
  }
}

.top {
  // width: 950px;
  height: 31px;
  display: flex;
}

.top-left-img {
  margin-top: 8px;
  width: 25px;
  height: 25px;
}

.top-midlle-img {
  width: 40px;
  height: 40px;
}

.top-midlle-span {
  margin-left: 20px;
  margin-top: 8px;
  height: 16px;
  font-size: 16px;
  color: #181818;
  font-weight: bold;
}

.top-right {
  margin-top: 2px;
  margin-left: 740px;
}

.tablabel {
  // width: 200px;
  p {
    font-size: 11px;
    color: #acacac;
    margin-bottom: 12px;
  }

  span {
    font-size: 11px;
    font-weight: bold;
    color: #000000;
  }

  .information {
    margin-top: 26px;
  }

  .information:nth-child(1) {
    margin-top: 10px;
  }

  .information:nth-child(3) {
    display: flex;

    div {
      width: 78px;
      margin-right: 129px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .information:nth-child(4) {
    display: flex;

    div {
      width: 78px;
      margin-right: 129px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements {
    margin-top: 26px;

    div {
      width: 81px;
    }
  }

  .requirements:nth-child(1) {
    margin-top: 10px;
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(2) {
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(3) {
    display: flex;

    div {
      margin-right: 260px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }

  .requirements:nth-child(4) {
    display: flex;

    p {
      height: 11px;
    }

    span {
      color: #4d71d9;
    }

    div {
      margin-right: 42px;
    }

    div:nth-last-child(1) {
      margin: 0;
    }
  }
}

::v-deep .el-tabs__nav-wrap::after {
  width: auto;
}

::v-deep .el-tabs__item {
  color: #acacac;
}

::v-deep .el-tabs__item.is-active {
  color: #4d71d9;
}

::v-deep .el-tabs__active-bar {
  height: 3px;
}
</style>
